export class ILLBusinessCategory {
  categoryId: string;
  label: string;
  description: string;
  activeFlag: string;
}
